// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[data-v-1603f10b] .giftStyle {\n  background: #f5f7fa94;\n}\n[data-v-1603f10b] .isErr {\n  color: red;\n}\n[data-v-1603f10b] .el-table th,\n.el-table tr[data-v-1603f10b] {\n  background: #e8e8e8 !important;\n}\n", ""]);
// Exports
module.exports = exports;
